<script lang="ts">
</script>

<svg
  data-testid="pause-svg"
  width="1em"
  height="1em"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path
    d="M5 0H7.69231V24H5V0ZM18.7308 0H16.5769C16.4288 0 16.3077 0.128571 16.3077 0.285714V23.7143C16.3077 23.8714 16.4288 24 16.5769 24H18.7308C18.8788 24 19 23.8714 19 23.7143V0.285714C19 0.128571 18.8788 0 18.7308 0Z"
    fill="#F5F5F5" />
</svg>
